import { post, put } from '@/request/http'
// 获取用户信息
export const getSimpleMemberInfo = p => post('/api/member/getSimpleMemberInfo.action', p)
export const getActivityInfo = p => post('/api/vipActivity/getActivityInfo.action', p)
export const getActivityWebCode = p => post('/api/weblogin/code.action', p)
export const getActivityWebLogin = p => post('/api/weblogin/login.action', p)
export const statSign = p => put('/api/statSign', p) // 埋点
